import Alpine from "alpinejs";

Alpine.data("layoutController", () => ({
  mobileMenuOpen: false,
  isConfirmationModalOpen: false,
  confirmationModalTitle: "",
  confirmationModalText: "",
  confirmationModalButtonText: "",
  onConfirmAction: null,
  toastNotificationMessage: "",
  toastNotificationType: "",
  isToastNotificationOpen: false,
  toastNotificationIcon: "",
  toastShowCloseButton: false,
  init() {
    this.$watch("isConfirmationModalOpen", value => {
      if (!value) {
        this.resetConfirmationModalState();
      }
    });
  },
  openMobileMenu() {
    this.mobileMenuOpen = true;
  },
  closeMobileMenu() {
    this.mobileMenuOpen = false;
  },
  // Confirmation modal
  openConfirmationModal({ title, description, buttonText, actionType, action }) {
    this.isConfirmationModalOpen = true;
    this.confirmationModalTitle = title;
    this.confirmationModalText = description;
    this.confirmationModalButtonText = buttonText;
    this.onConfirmAction = action;

    if (["remove", "delete", "cancel"].includes(actionType)) {
      this.modalQuestionIcon = "trash";
    }
  },
  closeConfirmationModal() {
    this.isConfirmationModalOpen = false;
    setTimeout(() => {
      this.resetConfirmationModalState();
    }, 1000);
  },
  clickLinkId(id) {
    document.getElementById(id).click();
  },
  resetConfirmationModalState() {
    this.confirmationModalTitle = "";
    this.confirmationModalText = "";
    this.confirmationModalButtonText = "";
    this.onConfirmAction = null;
  },
  showToastNotification(type, message) {
    this.toastNotificationMessage = message;
    this.toastNotificationType = type;
    this.toastShowCloseButton = ["error", "warning", "alert"].includes(type);

    setTimeout(() => (this.isToastNotificationOpen = true), 250);

    switch (type) {
      case "warning":
      case "alert": {
        this.toastNotificationIcon = "exclamation-circle";
        break;
      }
      case "error": {
        this.toastNotificationIcon = "exclamation-triangle";
        break;
      }
      default: {
        this.toastNotificationIcon = "check-circle";
        setTimeout(() => (this.isToastNotificationOpen = false), 3000);
      }
    }
  }
}));
